import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { City } from 'src/app/modules/entities/city';
import { Person } from 'src/app/modules/entities/person';
import { CategoryService } from 'src/app/modules/entities/service';
import { ServicePlace } from 'src/app/modules/entities/service-place';
import { PersonService } from 'src/app/modules/services/person.service';
import { environment } from 'src/environments/environment.development';
import { errorDescription, url } from 'src/app/modules/util/constants';
import { Table } from 'primeng/table';
import { Interaction } from 'src/app/modules/entities/interaction';
import { Subscription } from 'src/app/modules/entities/subscription';

interface Visibility {
  name: string,
  value: number
}

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css']
})
export class AdministrationComponent implements OnInit {

  constructor(private router: Router, private personService: PersonService, private cookies: CookieService, 
    private messageService: MessageService, private route: ActivatedRoute, private confirmationService: ConfirmationService) {
      this.route.params.subscribe(params => {
        this.setupParams(params['showAll']);
        //console.log(params['showAll']);
      });
    }

  personList: Person[] = [];
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  cities: City[] | undefined = undefined;
  servicePlaces: ServicePlace[] | undefined = undefined;
  categoryServices: CategoryService[] | undefined = undefined;
  visibilities: Visibility[] = [{name: 'Visible', value: 1}, {name: 'No visible', value: 0}];
  subscriptions: Subscription[] = [{description: 'Ninguno', id: 0, name: 'Ninguno', price: -1, image: ''},
    {description: 'VIP', id: 1, name: 'VIP', price: 20000, image: ''}, 
    {description: 'Clásico', id: 2, name: 'Clásico', price: 0, image: ''}]
  showAll: boolean = false;
  displayPasswordEdit: boolean = false;
  displayUsernameEdit: boolean = false;
  selectedUser: string = '';
  selectedPerson: string = '';
  visibleProfilesQuantity = 0;
  
  ngOnInit(): void {
    if (this.cookies.check('cities')) {
      this.cities = JSON.parse(this.cookies.get('cities'));
    }
  }

  setupParams(filter: number) {
    //console.log(filter);
    this.showAll = Boolean(filter);
    this.personService.getPersonListAdmin(this.showAll).subscribe({
      next: response => {
        if (response && response.status === 'success'){
          this.personList = response.data as Person[];
          this.visibleProfilesQuantity = this.personList.filter(a => a.visible === 1).length;
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

  getInteractions(type: string, interactions: Interaction[]) {
    return interactions.filter(x => x.type === type);
  }

  getIcon(servicePlace: string): string {
    switch (servicePlace) {
      case 'Hoteles':
        return 'pi pi-building'
      case 'Hoteles/Moteles':
        return 'pi pi-building'
      case 'A domicilio':
        return 'pi pi-car'
      case 'Lugar propio':
        return 'pi pi-home'
      default:
        return ''
    }
  }

  setAccessControl(field: string, person: Person) {
    let fieldTemp = 0;
    if (field === 'visible') {
      if (person.visible === 0) {
        fieldTemp = 1;
      } else if (person.visible === 1) {
        fieldTemp = 0;
      }
      this.visibleProfilesQuantity = this.personList.filter(a => a.visible === 1).length;
    } else if (field === 'verified') {
      if (person.verified === 0) {
        fieldTemp = 1;
      } else if (person.verified === 1) {
        fieldTemp = 0;
      }
    }
    this.personService.updateVisible(person.url_id, fieldTemp, field).subscribe({
      next: response => {
        if (response.status === 'success') {
          if (field === 'visible') {
            person.visible = fieldTemp;
          } else if (field === 'verified') {
            person.verified = fieldTemp;
          }
          this.messageService.add({severity: 'success', summary: 'Cambio exitoso'});
        } else {
          this.messageService.add({severity: 'error', summary: 'Ocurrió un error'});
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

  goToProfile(urlId: string) {
    this.router.navigate([url['perfil'], urlId]);
  }

  goToInteractionsStatistics() {
    this.router.navigate([url['interacciones']]);
  }

  goToSubscriptions() {
    this.router.navigate([url['suscripciones']]);
  }

  goToSubscriptionDetail(urlId: string) {
    this.router.navigate([url['detalle-suscripcion'], urlId]);
  }

  contactWhatsapp(person: Person) {
    //redirigir
    let contactUrl = 'https://api.whatsapp.com/send?phone=57' + person.user.userName;
    window.open(contactUrl);
  }

  clear(table: Table) {
    table.clear();
  }

  editPassword(user: string) {
    this.selectedUser = user;
    this.displayPasswordEdit = true;
  }

  editUsername(user: string, urlId: string) {
    this.selectedUser = user;
    this.selectedPerson = urlId;
    this.displayUsernameEdit = true;
  }

  editProfile(urlId: string) {
    this.router.navigate([url['editar-perfil'], urlId]);
  }

  deleteProfile(urlId: string, userName: string, index: number) {
    this.personService.deleteProfile(urlId, userName).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.messageService.add({
            detail: 'El perfil de ' + response.data.urlId + ' fue eliminado correctamente.',
            summary: 'Borrado correcto',
            severity: 'success'
          });
          this.personList.splice(index, 1);
        } else {
          this.messageService.add({
            detail: 'Error borrando perfil',
            severity: 'error'
          });
        }
      }
    });
  }

  confirmDelete(name: string, urlId: string, userName: string) {
    let index = this.personList.findIndex(person => person.url_id === urlId);
    this.confirmationService.confirm({
        header: 'Eliminar perfil de '+ name,
        message: 'Este proceso <b>NO</b> se puede deshacer y elimina toda la información relacionada. <b>¿Desea continuar?</b>',
        acceptIcon: 'pi pi-check mr-2',
        rejectIcon: 'pi pi-times mr-2',
        rejectButtonStyleClass: 'p-button grey',
        acceptButtonStyleClass: 'p-button-outlined p-button',
        acceptLabel: 'Eliminar',
        rejectLabel: 'Cancelar',
        accept: () => {
            this.deleteProfile(urlId, userName, index);
        },
        blockScroll: true,
        dismissableMask: true,
        closeOnEscape: true
    });
  }

}
